import {eatalianoAxios} from "@/data/api/http/axios";
import {CartTimeline} from "@/data/entities/cartTimeline";

/**
 * All carts of the restaurant created on a day (default: today), oldest
 * first, without their products. Admins only.
 */
export const getCartsOfDay = (restaurantId: number, date?: string): Promise<CartTimeline[]> => (
    eatalianoAxios
        .get<CartTimeline[]>(`/restaurant/cart/list/${restaurantId}`, {params: {date}})
        .then(response => response.data)
);
